import React, { useMemo, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { useStyles } from "./UptimeDowntimeBar.styles";
import { IUptimeDowntimeBar } from "./UptimeDowntimeBarInterfaces";

export const UptimeDowntimeBar = ({
    productionLineName,
    uptimeValue,
    downtimeValue,
    selected,
    allProductionLinesSelected,
    onClick,
}: IUptimeDowntimeBar) => {
    const classes = useStyles();
    const [uptimePercentage, setUptimePercentage] = useState<null | number>(null);
    const [downtimePercentage, setDowntimePercentage] = useState<null | number>(null);

    useMemo(() => {
        setDowntimePercentage(Math.ceil((downtimeValue / (downtimeValue + uptimeValue)) * 100));
        setUptimePercentage(Math.floor((uptimeValue / (downtimeValue + uptimeValue)) * 100));
    }, [uptimeValue, downtimeValue]);

    return (
        <main
            className={`${classes.container} ${classes.containerHover}`}
            style={{ opacity: selected || allProductionLinesSelected ? 1 : 0.5 }}
            onClick={onClick}
        >
            <Box className={classes.machineTitleContainer}>
                <Typography variant="error" className={classes.title}>
                    {productionLineName}
                </Typography>
                <Box className={classes.percentagesContainter}>
                    <Typography variant="subtitle2" className={classes.uptimeTitle}>
                        {`${uptimePercentage}%`}
                    </Typography>
                    <Typography variant="subtitle2" className={classes.downtimeTitle}>
                        {`${downtimePercentage}%`}
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.progressBar}>
                <Box className={classes.uptime} sx={{ width: `${uptimePercentage}%` }}></Box>
                <Box className={classes.downtime} sx={{ width: `${downtimePercentage}%` }}></Box>
            </Box>
            <Divider className={classes.divider} />
        </main>
    );
};
